import createCrud from '../crud';

export default createCrud({
  resource: 'aws-accounts',
  parent: 'stack'
});